export default __webpack_public_path__ + "static/media/til.72be6a9a.svg";